module.exports = __webpack_public_path__ + "assets/media/day28.ddc4a602.mp3";